const activatePreGeneratedAccount = {

	init: function() {


		// Functie die controleerd of akkoord is gegaan met de voorwaarden
		function checkVoorwaarden() {
			var verder = true;
			$('.voorwaardenAkkoordCheckbox').each(function() {
				if (!this.checked) {
					verder = false;
				}
			});
			return verder;
		}

		// Functie om te controleren of alle validaties in het formulier succesvol zijn afgerond
		function checkActivationForm() {
			if (
				checkVoorwaarden()
			) {
				$('button#btnActivateAccount').removeAttr('disabled');
			} else {
				$('button#btnActivateAccount').attr('disabled', 'true');
			}
		}

		// Controleer gehele formulier als voorwaarden checkbox wordt aangeklikt
		$('.voorwaardenAkkoordCheckbox').on('click', checkActivationForm);
	}

};

export default activatePreGeneratedAccount;
